import type { FC } from 'react';

import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { Layout } from '@wwe-portal/ui/features/subscription';
import { useElementSize } from '@wwe-portal/ui/hooks/use-element-size';

import type { MilestoneCollectionProps } from './milestone-collection';
import type { MilestonePeriodProps } from './milestone-period';
import MilestonePeriodV2 from './milestone-period-v2';

export interface MilestoneCarouselProps {
  milestones: MilestonePeriodProps[];
}

export function MilestoneCarouselSkeleton() {
  const [ref, { width }] = useElementSize();
  return (
    <div className="w-full" ref={ref}>
      <Layout
        items={[{ id: '0' }, { id: '1' }]}
        parentWidth={width}
        renderItem={({ id }) => {
          return (
            <Skeleton className="h-[189px] w-full max-w-[316px]" key={id} />
          );
        }}
      />
    </div>
  );
}

export const MilestoneCarousel: FC<MilestoneCollectionProps> = ({
  milestonePeriods,
  onMissionDetails,
  defaultMileStonePeriods,
}) => {
  const [ref, { width }] = useElementSize();
  const snapIndex = milestonePeriods?.findIndex((item) => item.id) ?? 0;
  return (
    <div className="w-full" ref={ref}>
      <Layout
        isRevamp
        items={milestonePeriods ?? defaultMileStonePeriods ?? []}
        parentWidth={width}
        renderItem={(item) => (
          <div className="max-w-[314px]">
            <MilestonePeriodV2
              data={item}
              {...item}
              onClick={() => onMissionDetails?.(item.id)}
              onReset={() => {}}
            />
          </div>
        )}
        snapIndex={snapIndex || 0}
      />
    </div>
  );
};
